// Persists a pending "validation" user-input request so it survives page reloads.
//
// Validation requests (the inline input the bot shows to collect e.g. an email or
// phone number) arrive as transient `custom` notifications, NOT as messages. They
// are therefore absent from the message history returned on reload, so without this
// the input control disappears after a refresh. We mirror the SDK's storage handling:
// access is wrapped in try/catch and degrades silently when storage is unavailable
// (private mode, blocked third-party storage), and keys are scoped per session so
// distinct conversations in the same browser never collide.

const KEY_PREFIX = 'amio_chat_pending_validation'

function getStorage (storageType) {
  try {
    return storageType === 'session' ? window.sessionStorage : window.localStorage
  } catch (e) {
    // Browsers can throw on storage access (e.g. Chrome Private Mode) - degrade silently.
    return null
  }
}

function keyFor (sessionId) {
  return sessionId ? `${KEY_PREFIX}_${sessionId}` : KEY_PREFIX
}

export function savePendingValidation (storageType, sessionId, payload) {
  const storage = getStorage(storageType)
  if (!storage) return
  try {
    storage.setItem(keyFor(sessionId), JSON.stringify(payload))
  } catch (e) { /* storage full/unavailable - degrade silently */ }
}

export function loadPendingValidation (storageType, sessionId) {
  const storage = getStorage(storageType)
  if (!storage) return null
  try {
    const raw = storage.getItem(keyFor(sessionId))
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function clearPendingValidation (storageType, sessionId) {
  const storage = getStorage(storageType)
  if (!storage) return
  try {
    storage.removeItem(keyFor(sessionId))
  } catch (e) { /* degrade silently */ }
}
